// 品番ルールに品番グループが無いときの案内（全台帳で同じ文面・正本はここ）。
// バックエンド services/sku_group_link.py の NO_GROUP_MESSAGE と同じ文言。
import { WarningCircle } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export const NO_SKU_GROUP_MESSAGE = 'この品番ルールに対応する品番グループがありません（設定 → カテゴリ・品番 で追加）';

export const MissingSkuGroupNote = ({ testId = 'missing-sku-group' }) => (
  <p className="mt-1 flex items-start gap-1 rounded border border-rose-200 bg-rose-50 px-2 py-1 text-[11px] font-medium leading-snug text-rose-700"
    data-testid={testId}>
    <WarningCircle size={13} className="mt-0.5 shrink-0" />
    <span>
      {NO_SKU_GROUP_MESSAGE}
      <Link to="/settings/taxonomy" className="ml-1 underline hover:text-rose-900"
        data-testid={`${testId}-link`}>
        カテゴリ・品番を開く
      </Link>
    </span>
  </p>
);

export default MissingSkuGroupNote;
